import { getDomains, getDomainForTrainings } from './domainsConfig';

// Options for step one
export const situationProOptions = [
  {
    id: '378',
    name: 'Salarié',
    icon: 'briefcase',
  },
  {
    id: '382',
    name: "Demandeur d'emploi",
    icon: 'magnifyingGlass',
  },
  {
    id: '384',
    name: 'Étudiant',
    icon: 'graduateHat',
  },
  {
    id: '1713',
    name: 'Fonctionnaire',
    icon: 'school',
  },
  {
    id: '388',
    name: 'Autres',
    silencedText: '(Exemple : indépendant, Freelance)',
    icon: 'ellipsis',
  },
];

export const objectifOptions = [
  {
    id: '2750',
    name: 'Améliorer mes compétences professionnelles',
    icon: 'target',
  },
  {
    id: '2751',
    name: 'Me reconvertir, changer de voie',
    icon: 'fingerPointing',
  },
  {
    id: '2752',
    name: 'Obtenir une certification, un diplôme reconnu',
    icon: 'student',
  },
  {
    id: '2753',
    name: 'Trouver un emploi',
    icon: 'magnifyingGlass',
  },
  {
    id: '2754',
    name: "Le plaisir simple d'apprendre",
    icon: 'stackOfBooks',
  },
  {
    id: '2755',
    name: 'Autre objectif professionnel',
    icon: 'ellipsis',
  },
];
export const CPF_FINANCEMENT_CODE = '2771';
export const ENTREPRISE_FORMATION_CONTEXT = 'formationContext';
export const ENTREPRISE_NAME = 'entrepriseName';
export const ALTERNANCE_MOBILITE = 'alternanceMobilite';
export const REDIRECTION_ZOHO_LEAD = 'redirectionZohoLead';

export const financementOptions = [
  {
    id: CPF_FINANCEMENT_CODE,
    name: 'Mon CPF',
    icon: 'folder',
    condition: '',
  },
  {
    id: '2772',
    name: 'Mes économies',
    icon: 'creditCard',
    condition: '',
  },
  {
    id: '2773',
    name: 'Mon entreprise',
    icon: 'officeBuilding',
    condition: ENTREPRISE_FORMATION_CONTEXT,
  },
  {
    id: '2774',
    name: 'Je cherche une alternance',
    icon: 'raisingHand',
    condition: REDIRECTION_ZOHO_LEAD,
  },
  {
    id: '3029',
    name: 'Autre moyen de financement (France Travail, Région, etc.)',
    icon: 'magnifyingGlass',
  },
  {
    id: '2775',
    name: 'Je ne sais pas encore',
    icon: 'ellipsis',
    condition: '',
  },
];

export const formationContextOptions = [
  {
    id: '3282',
    name: 'Je souhaite me former en tant que salarié',
    icon: 'briefcase',
    condition: '',
  },
  {
    id: '3283',
    name: 'Je suis responsable RH / Formation',
    icon: 'personRH',
    condition: '',
  },
  {
    id: '3284',
    name: 'Je souhaite réaliser un Plan de Développement des Compétences (PDC)',
    icon: 'graph',
    condition: '',
  },
  {
    id: '3285',
    name: `Je souhaite réaliser un Plan de Sauvegarde de l'Emploi (PSE)`,
    icon: 'mailbox',
    condition: '',
  },
  {
    id: '3286',
    name: `Je souhaite réaliser un Contrat de Sécurisation Professionnelle (CSP)`,
    icon: 'lock',
    condition: '',
  },
];

export const etudesOptions = [
  {
    id: '2743',
    name: 'Brevet',
    icon: 'yellowNotebook',
  },
  {
    id: '2744',
    name: 'CAP, BEP ou équivalent',
    icon: 'redNotebook',
  },
  {
    id: '2745',
    name: 'Bac ou équivalent',
    icon: 'greenNotebook',
  },
  {
    id: '2746',
    name: 'Bac +2',
    icon: 'blueNotebook',
  },
  {
    id: '2747',
    name: 'Bac +3',
    icon: 'orangeNotebook',
  },
  {
    id: '2788',
    name: 'Bac +4',
    icon: 'yellowNotebookAlt',
  },
  {
    id: '2748',
    name: 'Bac +5 et plus',
    icon: 'stackOfBooks',
  },
  {
    id: '2749',
    name: 'Aucun',
    icon: 'ellipsis',
  },
];

export const genderOptions = [
  {
    id: '2742',
    name: 'Madame',
  },
  {
    id: '2741',
    name: 'Monsieur',
  },
];

export const howDiscovered = [
  { id: '1879', label: 'Sur Internet' },
  { id: '1881', label: 'A la Télévision' },
  { id: '1883', label: "Par recommandation d'un ami" },
  { id: '1885', label: 'Dans la presse / radio' },
  { id: '1887', label: 'Autre' },
];
//getDomains
export const domains = getDomains();
export const formationsAlternance = [
  { bitrixId: 2380, bitrixName: 'CAP Esthétique' },
  { bitrixId: 3650, bitrixName: 'Bachelor Marketing et Communication' },
  { bitrixId: 2583, bitrixName: "Titre Comptable d'entreprise" },
  { bitrixId: 2578, bitrixName: 'Titre certifié Secrétaire médicale' },
  { bitrixId: 3058, bitrixName: 'Bachelor Ressources Humaines et Paie' },
  {
    bitrixId: 3061,
    bitrixName: 'Titre certifié Assistant(e) Ressources Humaines',
  },
  { bitrixId: 3062, bitrixName: 'Titre certifié Assistant(e) Commercial(e)' },
  { bitrixId: 3063, bitrixName: 'Titre certifié Assistant(e) Juridique' },
  { bitrixId: 3566, bitrixName: 'MBA Ressources Humaines' },
  { bitrixId: 3322, bitrixName: 'Titre Secrétaire Médicale' },
  { bitrixId: 3756, bitrixName: 'Bachelor Ressources Humaines' },
  { bitrixId: 3316, bitrixName: 'Bachelor Comptabilité' },
  { bitrixId: 3048, bitrixName: 'Bachelor Commerce' },
  { bitrixId: 3096, bitrixName: 'BTS MCO' },
  { bitrixId: 3673, bitrixName: 'BTS Comptabilité et Gestion' },
  { bitrixId: 3721, bitrixName: 'MBA Communication' },
  { bitrixId: 3644, bitrixName: 'BTS NDRC' },
];

export const ipacFormationsCBtoDisplay = [3451, 3452, 3400, 3401, 3402, 3677, 3676];

export const excludeFromCpfFinancement = ['1807', '3451', '3452' , '3045', '3234', '3400', '3401', '3402', '3757' ];

export const domainsForTrainings = getDomainForTrainings();

//! Tableau de correspondance des noms de formations marketables avec leur id bitrix pour automatiser l'affichage
export const overridesTrainingNames = {
  2559: {
    name: 'Bachelor Paie et Ressources Humaines',
  },
  3292: {
    name: 'Anglais',
  },
  3294: {
    name: 'Anglais Niveau B1',
  },

  3296: {
    name: 'Espagnol',
  },
  3298: {
    name: 'Responsable Logistique',
  },
  3756: [
    { id: 1, name: 'Bachelor Chargé(e) du recrutement' },
    { id: 2, name: 'Bachelor Ressources Humaines' },
  ],
  3061: {
    name: 'Assistant(e) de Direction - Option Ressources Humaines',
  },
  3062: {
    name: 'Assistant(e) de Direction - Option Commerciale',
  },
  3063: {
    name: 'Assistant(e) de Direction - Option Juridique',
  },
  3040: {
    name: 'Assistant(e) de Direction : Participer aux Projets Internes',
  },
  3032: {
    name: 'CAP Petite Enfance AEPE',
  },
  3013: {
    name: 'Piloter la Politique RH',
  },
  3016: {
    name: 'Webmaster',
  },
  3021: {
    name: 'Assistant(e) de Direction : Organiser la Communication Interne',
  },
  2988: {
    name: 'Langue des Signes',
  },
  2991: [
    { id: 1, name: 'Manager Commercial' },
    { id: 2, name: 'Commercial' },
  ],
  2835: [
    { id: 1, name: 'Développer la Performance Commerciale' },
    { id: 2, name: 'Closing' },
    { id: 3, name: 'Vente' },
    { id: 4, name: 'Business Developper' },
    { id: 5, name: 'Chargé d’Affaire' },
  ],
  2824: {
    name: 'Manager ses Équipes',
  },
  2825: {
    name: 'Manager à Distance pour Maintenir la Performance',
  },
  2792: {
    name: 'Piloter la Performance Webmarketing',
  },
  2797: [
    { id: 1, name: 'Définir la Stratégie Commerciale' },
    { id: 2, name: 'Stratégie Commerciale' },
  ],
  1807: [
    { id: 1, name: 'Prise de Parole en Public' },
    { id: 2, name: 'Éloquence' },
  ],
  2216: {
    name: 'Découvrir la Comptabilité',
  },
  2186: {
    name: 'Découvrir le Marketing Digital',
  },
  2569: {
    name: 'Chef de Projet Digital',
  },
  2208: {
    name: 'Découvrir la Gestion de Projet Digital',
  },
  2361: {
    name: 'Apprendre à Coder avec Python',
  },
  2172: [
    { id: 1, name: 'Transformation Digitale' },
    { id: 2, name: 'Digitalisation des Entreprises' },
  ],
  3234: {
    name: 'Gestion de Patrimoine',
  },
  3237: [
    { id: 1, name: 'Marketing & Digital' },
    { id: 2, name: 'Communication Digitale' },
  ],
  3315: [
    { id: 1, name: 'Comptabilité de Gestion' },
    { id: 2, name: 'Assistant Contrôleur de Gestion' },
  ],
  2542: [
    { id: 1, name: 'Comptabilité Fiscale et Financière' },
    { id: 2, name: 'Fiscalité' },
  ],
  3058: {
    name: 'Bachelor Ressources Humaines & Paie',
  },
  2578: {
    name: 'Secrétaire Médicale',
  },
  929: [
    { id: 1, name: 'Création d’Entreprise' },
    { id: 2, name: 'Gestion d’Entreprise' },
    { id: 3, name: 'Entrepreneuriat' },
  ],
  2532: {
    name: 'Nutrition et Diététique',
  },
  2548: {
    name: 'Secrétaire Médicale : Accueil & Communication',
  },
  2436: {
    name: 'Secrétaire Médicale : Suivi du Patient',
  },
  2452: {
    name: 'Comptabilité Générale',
  },
  2463: {
    name: 'Photoshop',
  },
  3387: [
    { id: 1, name: 'Créer un Site Internet' },
    { id: 2, name: 'Wordpress' },
  ],
  2848: [
    { id: 1, name: 'Fleuriste' },
    { id: 2, name: 'Composition Florale' },
  ],
  3757: [
    { id: 1, name: 'Décoration d\'Intérieur' },
    { id: 2, name: 'Home Staging' },
  ],
  2583: {
    name: 'Comptable d’Entreprise',
  },
  2605: {
    name: 'Gestion Administrative du Personnel',
  },
  935: [
    { id: 1, name: 'Filmer et Monter des Vidéos' },
    { id: 2, name: 'Monteur Vidéo' },
    { id: 3, name: 'Cadreur Vidéo' },
  ],
  2629: [
    { id: 1, name: 'Webdesigner' },
    { id: 2, name: 'UX Design' },
  ],
  2781: {
    name: 'Assistant(e) de Direction : Maîtriser les Outils Numériques',
  },
  2469: {
    name: 'Soins Esthétiques',
  },
  2435: [
    { id: 1, name: 'Maquillage et Soins' },
    { id: 2, name: 'Maquilleur Pro' },
  ],
  2475: [
    { id: 1, name: 'Prothésie Ongulaire' },
    { id: 2, name: 'Onglerie' },
  ],
  2979: {
    name: 'Chef de Projet Webdesign',
  },
  2978: {
    name: 'Négociation Immobilière',
  },
  2636: {
    name: 'Mandataire Immobilier',
  },
  2535: [
    { id: 1, name: 'Responsable Logistique' },
    { id: 2, name: 'Supply Chain Manager' },
  ],
  3364: {
    name: 'Gestionnaire de Paie',
  },
  3400: {
    name: 'Communication Interne',
  },
  3401: {
    name: 'Gestion du Temps',
  },
  3402: {
    name: 'Gestion des Conflits',
  },
  3409: {
    name: 'Excel débutant',
  },
  3410: {
    name: 'Excel avancé',
  },
  3451: {
    name: 'Comptabilité générale',
  },
  3452: {
    name: 'Comptabilité fiscale et financière',
  },
  3673: {
    name: 'BTS Comptabilité et Gestion',
  },
  3677: {
    name: 'Chef de projet évènementiel',
  },
  3676: {
    name: 'Réseaux sociaux et Webmarketing',
  },
  3720: [
    { id: 1, name: 'Créer et développer une activité de formation professionnelle' },
    { id: 2, name: 'Animer des actions de formation' },
    { id: 3, name: 'Créer un centre de formation' },
  ],
  3644: {
    name: 'BTS Négociation et Digitalisation de la Relation Client',
  },
};

//seuls ces champs seront tracké dans GTM
export const correspondanceBitrixToGtm = {
  etudes: etudesOptions,
  objectif: objectifOptions,
  financement: financementOptions,
  situationPro: situationProOptions,
  domainId: domains,
};
